import { API_FTL_AUTH_URL, API_FTL_CREDIT_ACCOUNT_URL, FTL_WEB_APP_API } from 'app/commons/constants/env.const'
import apiClient from 'app/commons/helpers/api/api'

import api from '../commons/helpers/api/index'

const authApi = {
  signIn: (signInData: any, xRecaptchaToken: string | null) =>
    api.post(
      `${API_FTL_AUTH_URL}/api/v1/customers/sign_in`,
      {},
      signInData,
      xRecaptchaToken && { headers: { 'X-Recaptcha-Token': xRecaptchaToken } }
    ),
  signUp: (signUpData: any, xRecaptchaToken: string | null) =>
    api.post(
      `${FTL_WEB_APP_API}/api/v3/customers/sign_up`,
      {},
      signUpData,
      xRecaptchaToken && { headers: { 'X-Recaptcha-Token': xRecaptchaToken } }
    ),
  resendCode: (xRecaptchaToken: string | null) =>
    api.post(
      `${FTL_WEB_APP_API}/api/v3/customers/resend_sms_token`,
      {},
      {},
      xRecaptchaToken && { headers: { 'X-Recaptcha-Token': xRecaptchaToken } }
    ),
  checkVerificationCode: (param: any, xRecaptchaToken: string | null) =>
    api.post(
      `${FTL_WEB_APP_API}/api/v3/customers/verify_sms_token`,
      {},
      param,
      xRecaptchaToken && { headers: { 'X-Recaptcha-Token': xRecaptchaToken } }
    ),
  updateCustomerSetting: (param: any) => api.put(`${FTL_WEB_APP_API}/api/v3/settings/customers`, param),
  resetPassword: (payload: any, xRecaptchaToken: string | null) =>
    api.post(
      `${FTL_WEB_APP_API}/api/v3/customers/password`,
      {},
      payload,
      xRecaptchaToken ? { headers: { 'X-Recaptcha-Token': xRecaptchaToken } } : {}
    ),
  convertToken: (authenticationToken: any, companyId: any) =>
    api.post(
      `${API_FTL_AUTH_URL}/api/v1/authentication/convert_token`,
      {},
      {
        ...(companyId ? { company_id: companyId } : {}),
        token: authenticationToken,
      }
    ),
  switchAccount: (companyId: any) =>
    api.post(
      `${API_FTL_AUTH_URL}/api/v1/customers/switch`,
      {},
      {
        account_id: companyId,
      }
    ),
  postJoinCustomerChatChanel: (data: any) =>
    api.post(`${FTL_WEB_APP_API}/api/v3/chat/customers/member`, '', { booking_id: data }),
  updateCustomerMe: (queryParam: any, xRecaptchaToken: string | null) =>
    api.put(
      `${FTL_WEB_APP_API}/api/v3/customers/me`,
      queryParam,
      undefined,
      xRecaptchaToken ? { headers: { 'X-Recaptcha-Token': xRecaptchaToken } } : {}
    ),
  getAccountCustomer: () => apiClient.get(`${API_FTL_AUTH_URL}/api/v1/customers/me?include[]=account_list`),
  getCustomerConfig: (accountId: any, queryParam: any, language: any) =>
    api.get(`${FTL_WEB_APP_API}/api/v3/settings/customers${accountId ? `?company_id=${accountId}` : ''}`, queryParam, {
      headers: {
        'Accept-Language': language,
      },
    }),
  getWallet: (countryCode: any) =>
    api.get(`${API_FTL_CREDIT_ACCOUNT_URL}/credit_amounts?country_code=${countryCode.toLowerCase()}`),
  deleteLogout: () => api.delete(`${FTL_WEB_APP_API}/api/v3/customers/sign_out`),
  getCustomer: (body: any) => api.put(`${API_FTL_AUTH_URL}/api/v1/customers/me`, '', body, { useFormData: true }),
  loginSocialAccount: (params: any, xRecaptchaToken: string | null) =>
    api.post(
      `${API_FTL_AUTH_URL}/api/v2/customers/login_via_social_account`,
      '',
      { ...params },
      xRecaptchaToken && { headers: { 'X-Recaptcha-Token': xRecaptchaToken } }
    ),
}

export default authApi
